import { ApexAccountTransactions } from '../../../investment/components/transactions/ApexAccountTransactions';

export default function AccountTransactions() {
    return <ApexAccountTransactions />;
}
